export default __webpack_public_path__ + "images/5669f6cca478fb83143d4511f28b1457-alternative_music.jpg";